import { UiLanguageKey } from 'locale/languages';

type UserName = {
  fistName: string;
  lastName: string;
};

export const displayUserName = (locale: UiLanguageKey, userName: UserName) => {
  switch (locale) {
    case 'ja':
      return `${userName.lastName} ${userName.fistName}`;
    default:
      return `${userName.fistName} ${userName.lastName}`;
  }
};
